import { BarChart, useChartColors } from "@/components/analytics";

interface MissingData {
  columns?: Array<{ name: string; missing_pct: number }>;
}

interface MissingVizProps {
  data: MissingData;
}

export function MissingViz({ data }: MissingVizProps) {
  const colors = useChartColors();

  if (!data?.columns || !Array.isArray(data.columns) || data.columns.length === 0) {
    return <p className="text-xs text-muted">No missing values detected.</p>;
  }

  const sortedData = [...data.columns].sort((a, b) => b.missing_pct - a.missing_pct);

  // Color function: Rose for >50%, primary otherwise
  const colorFn = (datum: Record<string, unknown>) => {
    const missingPct = datum.missing_pct as number;
    return missingPct > 50 ? "#F43F5E" : colors.primary;
  };

  return (
    <div>
      <h3 className="mb-3 font-mono text-sm font-semibold text-navy-600 dark:text-zinc-300">
        Missing Values by Column
      </h3>
      <BarChart
        data={sortedData}
        dataKey="missing_pct"
        nameKey="name"
        layout="horizontal"
        colorFn={colorFn}
        height={Math.max(300, sortedData.length * 30)}
      />
    </div>
  );
}
